'use client';

import React from 'react';
import posthog from 'posthog-js';
import { RealTimeAssessmentResults } from './results/RealTimeAssessmentResults';
import { useMockAssessmentAnalysis } from '@/hooks/use-mock-assessment-analysis';
import { getCustomResultPage } from '../custom-result-pages';
import Link from 'next/link';
import { ContinueButton } from '@/components/assessment/ContinueButton';
import { ReportCheckoutButton } from '@/components/report-checkout/ReportCheckoutButton';
import {
  Target,
  CheckCircle,
  ChevronDown,
  ChevronUp,
  Trophy,
  Calendar,
  Clock,
  Compass,
  MapPin,
  Sparkles,
} from 'lucide-react';

interface MockResultsWrapperProps {
  assessmentType: string;
  assessmentTitle: string;
  resultsType: 'generic' | 'ai';
}

export function MockResultsWrapper({
  assessmentType,
  assessmentTitle,
  resultsType,
}: MockResultsWrapperProps) {
  // Generate mock run data for test mode
  const mockRunId = `mock-${resultsType}-${Date.now()}`;
  const mockPublicAccessToken = `mock-token-${resultsType}`;
  const mockEmail = 'test@example.com';
  
  const CustomResultPage = getCustomResultPage(assessmentType);
  
  // Use mock analysis hook
  const mockAnalysis = useMockAssessmentAnalysis(resultsType, assessmentType);
  const { isComplete, analysisResult } = mockAnalysis;
  
  // Prepare result props
  const resultProps = {
    runId: mockRunId,
    publicAccessToken: mockPublicAccessToken,
    email: mockEmail,
    assessmentType: assessmentType,
    assessmentTitle,
    isTestMode: true,
    testResultsType: resultsType
  };

   return (
    <div className="min-h-screen bg-gray-50">
      {/* Progress indicator showing this as final step */}
      <div className="bg-white border-b">
        <div className="container mx-auto px-4 py-4">
          <div className="text-center text-sm text-gray-600">
            Test Mode: {resultsType === 'ai' ? 'AI-Generated' : 'Generic'} Results
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 py-8">
        {CustomResultPage ? (
          <CustomResultPage
            {...resultProps}
            isComplete={isComplete}
            analysisResult={analysisResult}
            posthog={posthog}
            components={{
              Link,
              ContinueButton,
              ReportCheckoutButton,
              icons: {
                Target,
                CheckCircle,
                ChevronDown,
                ChevronUp,
                Trophy,
                Calendar,
                Clock,
                Compass,
                MapPin,
                Sparkles,
              }
             }}
           />
        ) : (
          <RealTimeAssessmentResults {...resultProps} />
        )}
      </div>
    </div>
  );
}

// Default export for backward compatibility
export default MockResultsWrapper;
